export enum QueryKeys {
  BrandConfig = "brandConfig",
  Cart = "cart",
  Products = "products",
  Wishlist = "wishlist",
}

export const CacheTime = {
  OneHour: 60 * 60 * 1000,
  ThirtyMinutes: 30 * 60 * 1000,
  TenMinutes: 10 * 60 * 1000,
} as const;

export const cacheConfig = {
  oneHour: {
    staleTime: CacheTime.OneHour,
    refetchInterval: CacheTime.OneHour,
  },
  thirtyMinutes: {
    staleTime: CacheTime.ThirtyMinutes,
    refetchInterval: CacheTime.ThirtyMinutes,
  },
  tenMinutes: {
    staleTime: CacheTime.TenMinutes,
    refetchInterval: CacheTime.TenMinutes,
  },
} as const;
